module.exports = __webpack_public_path__ + "img/practice-3.4896c77c.jpg";